export default __webpack_public_path__ + "static/LeituraTwo-Medium-ab1193a2ca3a2e2eafd5f73a5c48ebbc.woff";